<template>
  <div class="common-text-box-small mb-4">
    <div v-show="showTitle" class="flex items-center justify-start mb-2">
      <span class="mr-2">{{ title }}</span>
      <span :v-show="required" class="required"> * </span>
    </div>
    <v-select
      class="w-full"
      v-model="inputValue"
      :options="options"
      :placeholder="placeholder"
      :class="{ 'is-error': error }"
    >
    </v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";


export default {
  name: "M.CommonSelectBoxSmall",
  props: {
    title: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: false
    },
    validate: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false
    }


  },
  components: {
    vSelect
  },

  data() {
    return {
      inputValue: null,
      error: false
    }
  }

}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-text-box-small {
  .required {
    color: $aisea-red;
  }

  .is-error {
    border: solid 1px $aisea-red !important;
    border-radius: 4px;
  }
}
</style>